import { getOrderFromOrderedListNode } from '@atlaskit/editor-common/utils';
import { reduce } from './';
var orderedList = function orderedList(node, schema) {
  var result = [];
  var order = getOrderFromOrderedListNode(node);
  node.forEach(function (n, _offset, index) {
    result.push("".concat(index + order, ". ").concat(reduce(n, schema)));
  });
  return result.join('\n');
};
export default orderedList;